import { render, staticRenderFns } from "./TwitterImage.vue?vue&type=template&id=4fc71288&scoped=true"
import script from "./TwitterImage.vue?vue&type=script&lang=js"
export * from "./TwitterImage.vue?vue&type=script&lang=js"
import style0 from "./TwitterImage.vue?vue&type=style&index=0&id=4fc71288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc71288",
  null
  
)

export default component.exports